import "./LogoLoader.css";

const LogoLoader = () => {
  return (
    <div className="logo-loader-wrapper">
      <img src="https://d2lvj32mp5x83n.cloudfront.net/static/YQ+1+(1).png" alt="Loading..." className="logo-loader" />
    </div>
  );
};

export default LogoLoader;
